import styles from "./modifiedSidebar.module.scss";
import SubMenu from "./subMenu";
// import { sidebarData } from "./data";
import { ReactComponent as Logo } from "../../../svgs/cipm-logobig-e1650631957250 4.svg";
import { ReactComponent as LogoutIcon } from "../../../svgs/log-out.svg";
import { logout } from "../../../utils/logout";
import { userAtom } from "../../../utils/store";
import { useAtom } from "jotai";
import apiCall from "../../../utils/apiCall";
import { useQuery } from "@tanstack/react-query";
import { ReactComponent as DashIcon } from "../../../svgs/dash.svg";
import { ReactComponent as MemberIcon } from "../../../svgs/members.svg";
import { ReactComponent as EventIcon } from "../../../svgs/event.svg";
import { ReactComponent as OverviewIcon } from "../../../svgs/overview.svg";
import { ReactComponent as SettingIcon } from "../../../svgs/setting.svg";
import { ReactComponent as DescriptionIcon } from "../../../svgs/description.svg";
import { ReactComponent as TransactionIcon } from "../../../svgs/transactions.svg";
import { ReactComponent as ReportIcon } from "../../../svgs/reports.svg";
const ModifiedSidebar = () => {
  const [user] = useAtom(userAtom);

  const getAllRolePermission = async () => {
    const url = `/MembershipSetUp/member/GetAllRolePermission?actionType=${2}`;

    return await apiCall().get(url);
  };

  const {
    data: rolePermission,
   
  } = useQuery({
    queryKey: ["get-AllRolePermission"],
    queryFn: getAllRolePermission,
    refetchOnWindowFocus: false,
    retry: 0,
    enabled: true,
  });

  const rolePermissionData = rolePermission?.data?.Data || [];

  const filterRolesByPermission = (permissionName: string): string[] => {
    return rolePermissionData
      ?.filter((role: any) => role.PermissionName === permissionName)
      ?.map((role: any) => role.RoleName); // Extract only RoleId values
  };



  const sidebarData = [
    {
      title: "Overview",
      icon: <OverviewIcon />,
      path: "/overview",
      roles: filterRolesByPermission("Overview"),
    },
    {
      title: "Settings",
      icon: <SettingIcon />,
      path: "/settings",
      roles: filterRolesByPermission("Settings"),
    },
    {
      title: "Members",
      icon: <MemberIcon />,
      subNav: [
        {
          title: "All Members",
          path: "/members/all-members",
          icon: <DashIcon />,
          roles: filterRolesByPermission("All Members"),
          // roles: [], // Available to all roles
        },
        // {
        //   title: "License Register",
        //   path: "/members/license-register",
        //   icon: <DashIcon />,
        //   roles: filterRolesByPermission("License Register"),
        // },
        {
          title: "Individuals",
          path: "/members/individuals",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Individuals"),
        },
        {
          title: "Corporate",
          path: "/members/corporate",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Corporate"),
        },
        {
          title: "Applicants",
          path: "/members/applicants",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Applicants"),
        },
        {
          title: "All Messages",
          path: "/messages",
          icon: <DashIcon />,
          roles: filterRolesByPermission("All Messages"),
        },
      ],
    },
    {
      title: "Events",
      icon: <EventIcon />,
      subNav: [
        {
          title: "License Renewal Exams",
          path: "/events/license-renewal-exams",
          icon: <DashIcon />,
          roles: filterRolesByPermission("License Renewal Exams"),
        },
        {
          title: "Events Details",
          path: "/events/events-details",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Events Details"),
        },
        {
          title: "Events Register",
          path: "/events/events-register",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Events Register"),
        },
             {
          title: "Undergraduate Registration",
          path: "/events/undergraduate-registration",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Undergraduate Registration"),
        },
      ],
    },
    {
      title: "Applications",
      icon: <DescriptionIcon />,
      subNav: [
        {
          title: "Change Of Officer",
          path: "/applications/corporate-profile-update/change-of-officer",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Change Of Officer"),
        },
        {
          title: "Change of Address",
          path: "/applications/corporate-profile-update/change-of-address",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Change of Address"),
        },
        {
          title: "Change Of Name",
          path: "/applications/change-of-name",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Change Of Name"),
        },
        {
          title: "Change Of Marital Status",
          path: "/applications/change-of-marital-status",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Change Of Marital Status"),
        },
        {
          title: "Invoice Request",
          path: "/applications/invoice-request",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Invoice Request"),
        },
        {
          title: "Review HRPL Activities",
          path: "/applications/HRPL-activities",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Review HRPL Activities"),
          // roles: ["HRPL Admin"], // Only for HRPL Admin
        },
        {
          title: "Membership Upgrade",
          path: "/applications/membership-upgrade",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Membership Upgrade"),
          // roles: ["Admin Officer", "Membership Committee Chairman", "Leadership"], // For specified roles
        },
        {
          title: "Upgrade Member Level",
          path: "/applications/upgrade-member-level",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Upgrade Member Level"),
          // roles: ["Leadership"], // For specified roles
        },
      ],
    },
    {
      title: "Transactions",
      icon: <TransactionIcon />,
      subNav: [
        {
          title: "Transaction History",
          path: "/transaction/transaction-history",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Transaction History"),
        },
        {
          title: "Debit Note",
          path: "/transaction/debit-note",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Debit Note"),
        },
        {
          title: "Corporate Pending Invoice",
          path: "/transaction/corporate-pending-invoice",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Corporate Pending Invoice"),
        },
        {
          title: "Outstanding Payments",
          path: "/transaction/outstanding-payment",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Outstanding Payments"),
        },
      ],
    },
    {
      title: "Reports",
      icon: <ReportIcon />,
      subNav: [
        {
          title: "Badge Reports",
          path: "/reports/conference-barge",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Badge Reports"),
        },
      
        {
          title: "Membership Upgrade Reports",
          path: "/report/upgrade-register",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Membership Upgrade Reports"),
        },
        {
          title: "Chairman Reports",
          path: "/report/chairman-reports",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Chairman Reports"),
        },
        {
          title: "Endorsement Reports",
          path: "/report/endorsement",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Endorsement Reports"),
        },
        {
          title: "Non Member Organization Reports",
          path: "/report/non-member-organization-reports",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Non Member Organization Reports"),
        },
        {
          title: "Debit Note Reports",
          path: "/report/debit-note-reports",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Debit Note Reports"),
        },
      ],
    },
    {
      title: "HRPL Reports",
      icon: <ReportIcon />,
      subNav: [
     
        {
          title: "HRPL Reports",
          path: "/reports/license-register",
          icon: <DashIcon />,
          roles: filterRolesByPermission("License Register Reports"),
        },
        {
          title: "First Time License Applicants",
          path: "/reports/first-license-applicants",
          icon: <DashIcon />,
          roles: filterRolesByPermission("License Register Reports")
        },


        {
          title: "License Reports",
          path: "/reports/license-report",
          icon: <DashIcon />,
          roles: filterRolesByPermission("License Register Reports")
        },
        {
          title: "HR Work Activities",
          path: "/reports/Hr-work-activities-reports",
          icon: <DashIcon />,
          roles: filterRolesByPermission("License Register Reports")
        },
        {
          title: "HR License Status",
          path: "/reports/hr-license-Status-reports",
          icon: <DashIcon />,
          roles: filterRolesByPermission("License Register Reports"),
        },

        {
          title: "License Register",
          path: "/members/license-register",
          icon: <DashIcon />,
          roles: filterRolesByPermission("License Register"),
        },
       
      ],
    },
    {
      title: "Activities",
      icon: <ReportIcon />,
      subNav: [
        {
          title: "All Activities",
          path: "/activities",
          icon: <DashIcon />,
          roles: filterRolesByPermission("All Activities"),
        },
        {
          title: "Event Activities",
          path: "/event/activities",
          icon: <DashIcon />,
          roles: filterRolesByPermission("Event Activities"),
        },
      ],
    },
    {
      title: "Ready To Market",
      icon: <ReportIcon />,
      path: "/ready-to-market",
      roles: filterRolesByPermission("Ready To Market"),
    },
  ];

  // Extract the role names from user
  const userRoleNames = user?.RoleNames || [];
  // const userRoleIds = user?.RoleIds || [];

  const userFirstName = user?.FirstName || ""; // Default to empty string if user.FirstName is undefined

  const firstNameInitials = userFirstName.substring(0, 2).toUpperCase(); // Ensure initials are in uppercase

  // Filter the sidebarData based on user roles
  const filteredSidebarData = sidebarData.filter((item: any) => {
    // Check if the item has roles and if they intersect with user roles
    if (item.roles && item.roles.length > 0) {
      return item.roles.some((role: string) => userRoleNames.includes(role));
    }
    if (item.subNav && item.subNav.length > 0) {
      item.subNav = item.subNav.filter((subItem: any) => {
        if (subItem.roles && subItem.roles.length > 0) {
          return subItem.roles.some((role: string) =>
            userRoleNames.includes(role)
          );
        }
        return true; // If no roles are specified, include the item
      });
    }
    return true; // If no roles are specified, include the item
  });

  // // Filter the sidebarData based on user roles
  // const filteredSidebarData = sidebarData.filter((item: any) => {
  //   // Check if the item has roles and if they intersect with user roles
  //   if (item.roles && item.roles.length > 0) {
  //     return item.roles.some((role: string) => userRoleNames.includes(role));
  //   }
  //   if (item.subNav && item.subNav.length > 0) {
  //     item.subNav = item.subNav.filter((subItem: any) => {
  //       if (subItem.roles && subItem.roles.length > 0) {
  //         return subItem.roles.some((role: string) => userRoleNames.includes(role));
  //       }
  //       return true; // If no roles are specified, include the item
  //     });
  //   }
  //   return true; // If no roles are specified, include the item
  // });

  return (
    <nav className={styles.nav}>
      <div className={styles.typogragphy}>
        <span className={styles.wrapper}>
          <Logo className={styles.logo} />
          <span>
            <p className={styles.name}>CIPM</p>
            <p className={styles.title}>Membership Portal</p>
          </span>
        </span>
        <span className={styles.wrapper}>
          <span className={styles.profilePic}>{firstNameInitials}</span>
          <span>
            <p className={styles.name}>{userFirstName}</p>
            {/* <p className={styles.title}>{userRoleNames.join(', ')}</p> */}
          </span>
        </span>
      </div>
      {filteredSidebarData?.map((item, index) => (
        <SubMenu
          key={index}
          subNav={item.subNav}
          title={item.title}
          icon={item.icon}
          path={item.path}
        />
      ))}
      <div className={styles.groupLogout} onClick={logout}>
        <LogoutIcon />
        <span className={styles.logout}>Logout</span>
      </div>
    </nav>
  );
};

export default ModifiedSidebar;
